import { useState, useEffect, useCallback } from "react";
import { CommonPropertyProps, Payload } from "schemas/elements";
import SearchSelectContainer from "components/FormDesigner/elements/SearchSelect/SearchSelectContainer";
import api from "lib/api";
import { status } from "../../../../constants";
import axios from "axios";
import { AlertProps, SearchSelectOptionProps } from "@alm/flow-ds/components";

type Props = Omit<CommonPropertyProps, "value"> & {
	value: SearchSelectOptionProps | Payload;
	nextProp: keyof Payload;
	addAlert: (alert: string, status: AlertProps["status"]) => void;
};

export default ({
	updateStore,
	field,
	required,
	value,
	desc,
	validation,
	elementIndex,
	nextProp,
	addAlert,
	nestedField,
}: Props) => {
	const [entities, setEntities] = useState<SearchSelectOptionProps[]>([]);
	const [loading, setLoading] = useState<boolean>(true);

	const getEntitiesList = useCallback(async () => {
		// Get entities from API
		try {
			const res = await api.entity.getEntities();
			setEntities(res);
		} catch (error) {
			addAlert("errorLoadingFormList", status.ERROR);
			if (error && axios.isAxiosError(error))
				console.error(`Error: ${error.message}`);
		}
		setLoading(false);
	}, [addAlert]);

	useEffect(() => {
		getEntitiesList();
	}, [getEntitiesList]);

	const props = {
		updateStore,
		field,
		required,
		value,
		desc,
		validation,
		loading,
		elementIndex,
		nextProp,
		options: entities,
		disabled: entities.length ? false : true,
		nestedField,
	};

	return <SearchSelectContainer {...props} />;
};
